import { Select } from 'antd';
import { DEV_LANG_ENABLED } from 'translations';
import { useTranslation } from 'translations/hooks';
import { Locale } from 'translations/types';

interface LanguageData {
  label: string;
  value: Locale;
}

const AVAILABLE_LANGUAGES: LanguageData[] = [
  { label: '🇫🇷 FR', value: Locale.fr },
  { label: '🇬🇧 UK', value: Locale.enGB },
  { label: '🇺🇸 US', value: Locale.enUS },
  { label: '🇪🇸 ES', value: Locale.es },
  ...(DEV_LANG_ENABLED ? [{ label: '🛠️ Dev', value: Locale.dev }] : []),
] as const;

const DEFAULT_LANGUAGE = AVAILABLE_LANGUAGES[0];

export const LanguageSelector = () => {
  const { language, changeLanguage } = useTranslation();

  const defaultValue =
    AVAILABLE_LANGUAGES.filter((lang) => lang.value === language)[0] ??
    DEFAULT_LANGUAGE;

  return (
    <Select<Locale>
      className="text-base"
      popupMatchSelectWidth={false}
      defaultValue={defaultValue.value}
      onChange={(value) => {
        changeLanguage(value);
      }}
      options={AVAILABLE_LANGUAGES}
    />
  );
};
